/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Scheduletext1Inputs */

const en__field_scheduletext1 = /** @type {(inputs: _Field_Scheduletext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does your schedule look like in a normal week? How many hours do you spend on studying and working? How much time do you have to learn German? (50–150 words)`)
};

const de__field_scheduletext1 = /** @type {(inputs: _Field_Scheduletext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie sieht dein Zeitplan in einer normalen Woche aus? Wie viele Stunden verbringst du mit Studium und Arbeiten? Wie viel Zeit hast du zum Deutschlernen? (50–150 Wörter)`)
};

/**
* | output |
* | --- |
* | "What does your schedule look like in a normal week? How many hours do you spend on studying and working? How much time do you have to learn German? (50–150 w..." |
*
* @param {_Field_Scheduletext1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_scheduletext1 = /** @type {((inputs?: _Field_Scheduletext1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Scheduletext1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_scheduletext1(inputs)
	return de__field_scheduletext1(inputs)
});
export { _field_scheduletext1 as "_field_scheduleText" }